import React, { useRef, useEffect } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

const Main = styled.main`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
  align-items: center;
  padding: 2rem;
  min-height: 60vh;
  background: #fbfbec;
  background-image: url(${require('../images/fleet1.jpg')});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  @media (max-width: 600px) {
    padding: 1rem;
  }
`;

const MainContent = ({ children }) => {
  const mainRef = useRef(null);
  const { pathname } = useLocation();

  useEffect(() => {
    if (mainRef.current) {
      mainRef.current.scrollTop = 0;
    }
  }, [pathname]);

  return <Main ref={mainRef}>{children}</Main>;
};

MainContent.propTypes = {
  children: PropTypes.node,
};

export default MainContent;
